import { request } from '@/shared/api/request'

export const deleteMembers = (externalId, page, size, isEmployee, data) => {
	return request({
		url: `colcontract/tradeUnion/person/delete/${externalId}?page=${page}&?size=${size}&isEmployee=${isEmployee}`,
		method: 'POST',
		data: data,
	})
}
